'use client';

import Select from '@/components/ui/Select';

/** Same options as skaiciuokle Step6Personal */
export const PHONE_COUNTRY_CODES = [
  { value: '+370', label: '🇱🇹 +370' },
  { value: '+48', label: '🇵🇱 +48' },
  { value: '+46', label: '🇸🇪 +46' },
  { value: '+358', label: '🇫🇮 +358' },
  { value: '+372', label: '🇪🇪 +372' },
  { value: '+371', label: '🇱🇻 +371' },
  { value: '+44', label: '🇬🇧 +44' },
  { value: '+49', label: '🇩🇪 +49' },
  { value: '+33', label: '🇫🇷 +33' },
  { value: '+39', label: '🇮🇹 +39' },
  { value: '+34', label: '🇪🇸 +34' },
  { value: '+31', label: '🇳🇱 +31' },
  { value: '+32', label: '🇧🇪 +32' },
  { value: '+45', label: '🇩🇰 +45' },
  { value: '+47', label: '🇳🇴 +47' },
  { value: '+1', label: '🇺🇸 +1' },
  { value: '+7', label: '🇷🇺 +7' },
  { value: '+380', label: '🇺🇦 +380' },
];

/**
 * Country code select + 8-digit national number (skaiciuokle Step 6 pattern).
 * Select border is off — wrapper (inputWithIcon) provides the outer border.
 */
export default function PhoneNumberInput({
  countryCode = '+370',
  onCountryCodeChange,
  value = '',
  onChange,
  id,
  wrapperClassName = '',
  inputClassName = '',
  placeholder,
  autoComplete = 'tel-national',
}) {
  return (
    <div className={wrapperClassName}>
      <Select
        options={PHONE_COUNTRY_CODES}
        value={countryCode || '+370'}
        onChange={onCountryCodeChange}
        hasBorder={false}
      />
      <input
        id={id}
        className={inputClassName}
        type='tel'
        value={value}
        onChange={e => onChange(e.target.value.replace(/\D/g, '').slice(0, 8))}
        maxLength={8}
        autoComplete={autoComplete}
        placeholder={placeholder}
        suppressHydrationWarning
      />
    </div>
  );
}
